import comp from "./TimePicker";

export default comp;
